import { css } from '@emotion/react'

/**
 * CSS 通用封装 - 文字超出省略为 ...
 * @param value CSS 属性值，默认 100%
 * @param property CSS 属性名称，默认 width
 * @returns
 */
export const textOverflow = (value = '100%', property: 'width' | 'max-width' = 'width') =>
  css({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [property]: value,
  })

export const url = (address: string): string => `url("${address}")`

export const notificationUnreadMark = ({ top = '0', left = '8px' } = {}) =>
  css({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ':after': {
      content: '""',
      display: 'inline-block',
      position: 'relative',
      top,
      width: '6px',
      height: '6px',
      left,
      borderRadius: '50%',
      backgroundColor: '#c14a3f',
    },
  })

export const backgroundImage = (backgroundImage: string, width: string, height = width) =>
  css({
    width,
    height,
    backgroundImage: url(backgroundImage),
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  })
